import { Version } from './version';

export const ZOP_VERSION = new Version('0.1.0').full;
